export const SAMPLE_STATE_DATA = [
  { label: '待打版', value: 1, children: [] },
  { label: '打版中', value: 2, children: [] },
  { label: '已打版', value: 3, children: [] },
  { label: '打样中', value: 4, children: [] },
  { label: '已打样', value: 5, children: [] },
  { label: '采买中', value: 7, children: [] },
  { label: '已采买', value: 8, children: [] },
  { label: '已入库', value: 6, children: [] }
]

export const getSampleStatusText = ({ process, stepId }) => {
  const name = process?.steps?.find(item => item.id === stepId)?.stepName
  return name
}

export const getSampleStatusValue = ({ processId, stepStatus, stepId }) => {
  if (processId > 0) {
    if (stepStatus === -1) {
      return `${processId},${processId},-1`
    }
    if (stepStatus === 0 || stepStatus === 2) {
      return `${processId},${stepId},0`
    }
    if (stepStatus === 1) {
      return `${processId},${stepId},1`
    }
    return `${processId},${processId},3`
  }
  return null
}

export const getSampleStatusLabel = ({ process, processId, stepStatus, stepId, state }) => {
  if (processId > 0) {
    if (stepStatus === -1) {
      return '已终止'
    }
    if (stepStatus === 0 || stepStatus === 2) {
      return `待${getSampleStatusText({ process, stepId })}`
    }
    if (stepStatus === 1) {
      return `${getSampleStatusText({ process, stepId })}中`
    }
    return '已入库'
  }
  return SAMPLE_STATE_DATA.find(m => state == m.value)?.label
}

export const getSampleStatusList = ({ process }) => {
  return process?.map(item => {
    const _children = []
    item?.steps?.forEach((chid, index) => {
      if (index + 1 === item?.steps?.length) {
        _children.push({
          value: `${item.id},${chid.id},0`,
          label: `待${chid.stepName}`,
          name: `待${chid.stepName}`,
          stepStatus: 1,
        })
      } else {
        _children.push({
          value: `${item.id},${chid.id},0`,
          label: `待${chid.stepName}`,
          name: `待${chid.stepName}`,
          stepStatus: 0,
        })
        _children.push({
          value: `${item.id},${chid.id},1`,
          label: `${chid.stepName}中`,
          name: `${chid.stepName}中`,
          stepStatus: 1,
        })
      }
    })
    _children.push({
      value: `${item?.id},${item?.id},3`,
      label: '已入库',
      name: '已入库',
      stepStatus: 1,
    })
    _children.push({
      value: `${item?.id},${item?.id},-1`,
      label: '已终止',
      name: '已终止',
      stepStatus: 1,
    })
    return {
      value: item?.id,
      label: item?.processName,
      children: _children
    }
  })
}
